// extracted by mini-css-extract-plugin
export default {"news-card":"newsCard_news-card__RoKyc","header":"newsCard_header__jR73f","body":"newsCard_body__Bwua0","footer":"newsCard_footer__ndVc-"};